import React from 'react';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import DoneIcon from '@material-ui/icons/Done';

import Input from '../../components/Input/Input';

const styles = theme => ({
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
  success: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

class NewPasswordForm extends React.Component {
  state = {
    password: '',
    submited: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props
      .onNewPassword({ password: this.state.password }, this.props.match.params.token)
      .then(() => this.setState({ submited: true }))
      .catch(error => error);
  };

  handleChange = (event) => {
    this.setState({ password: event.target.value });
  };

  render() {
    const { classes, loading } = this.props;
    const { password, submited } = this.state;

    return submited ? (
      <div className={classes.success}>
        <DoneIcon color="primary" />
        <Typography variant="body1" color="primary">Sua senha foi alterada com sucesso !</Typography>
      </div>
    ) : (
      <form onSubmit={this.handleSubmit}>
        <Input
          name="password"
          label="Nova Senha"
          elementType="passwordToggle"
          value={password}
          onChange={this.handleChange}
          required
          fullWidth
          margin="normal"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          disabled={loading || password.trim() === ''}
        >
          {loading ? <CircularProgress size={25} color="primary" /> : 'CONFIRMAR'}
        </Button>
      </form>
    );
  }
}

export default withRouter(withStyles(styles)(NewPasswordForm));
